import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Relationship from 'facet-rest/src/domain/Relationship';
import { useChiliPiperContext } from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs } from 'Helpers/Testing';
import { FDClickableText } from '@facet-wealth/design';
import ChiliPiperComponentInFullScreenDialog
  from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperComponentInFullScreenDialog';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';

const ChiliPiperRescheduleMeeting = ({
  meetingResource,
  relationship,
  refreshMeetings,
  autoOpen,
}) => {
  const { displayErrorMessage } = useSnackbarContext();

  const doRedirect = async () => {
    try {
      await refreshMeetings();
    } catch (e) {
      displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to refresh meetings');
    }
  };

  const {
    setOpenIFrame, chiliPiperRel, openIFrame, handleChiliPiperExit,
  } = useChiliPiperContext(meetingResource, doRedirect, relationship.attr('name'));

  // Auto-open ChiliPiper dialog when autoOpen prop is true
  useEffect(() => {
    if (autoOpen) {
      setOpenIFrame(true);
    }
  }, [autoOpen, setOpenIFrame]);

  return (
    ((openIFrame && chiliPiperRel) ? (
      <ChiliPiperComponentInFullScreenDialog chiliPiperRel={chiliPiperRel} handleChiliPiperExit={handleChiliPiperExit} />
    ) : (
      <FDClickableText
        appearance={'standalone'}
        size={'sm'}
        onClick={() => {
          setOpenIFrame(true);
        }}
        label={relationship.meta('prompt')}
        {...dataAttrs('chili-piper-reschedule-meeting-button')}
      />
    )
    ));
};

ChiliPiperRescheduleMeeting.defaultProps = {
  autoOpen: false,
};

ChiliPiperRescheduleMeeting.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
  meetingResource: PropTypes.object.isRequired,
  refreshMeetings: PropTypes.func.isRequired,
  autoOpen: PropTypes.bool,
};

export default ChiliPiperRescheduleMeeting;
